<template>
  <div class="container-fluid full-height-page-wrapper">

    <PageHeader showBreadcrumbs page-title="Sales report historical">
      <template #buttons>
        <b-form-group class="btn-icon button-checkbox_sm w-100">
            <b-form-checkbox
              size="sm"
              switch
              v-model="showLastMonth"
              class="switch"
              >Show last month</b-form-checkbox>
          </b-form-group>
      </template>
    </PageHeader>

    <div class="d-flex align-items-center mb-3">
      <span class="mr-3 title-sales">Revenue by:</span>
      <b-form-group class="btn-icon revenue-group  mb-0 button-checkbox_sm w-100">
      <b-form-checkbox
        v-for="(groupData, groupName) in revenueGroups"
        :key="groupName"
        v-model="groupData.visible"
        size="sm"
        switch
        class="switch mr-4">{{ groupData.label }}</b-form-checkbox>
      </b-form-group>
    </div>
    <div class="d-flex align-items-center mb-3">
      <span class="mr-3 title-sales">New projects count by:</span>
      <b-form-group class="btn-icon revenue-group  mb-0 button-checkbox_sm w-100">
        <b-form-checkbox
        v-for="(groupData, groupName) in newProjectsGroups"
        :key="groupName"
        v-model="groupData.visible"
        size="sm" switch class="switch mr-4"
      >{{ groupData.label }}</b-form-checkbox>
      </b-form-group>
    </div>

    <div v-if="isDataPageLoading" class="content-loading-wrapper" style="min-height: 60vh;">
      <Preloader class="centered-preloader large-spinner" />
    </div>

    <div v-else class="full-height-content">
      <div v-if="reportData.data.length > 0">
        <div ref="tableContain">
          <HistoricalReportTable
            class="sales-report-historical mb-0 table__theme-default slideout__table position-relative"
            :fixed="false"
            hover
            responsive
          >
            <b-thead
              head-variant="light"
              :class="{ 'sticky-head': getCoordinates > 0 }"
              :style="{ top: getCoordinates + 'px' }"
            >
              <tr
                class="group-border group-border-header common-header"
              >
                <th rowspan="2" class="date-column text-left">date</th>
                <th rowspan="2">revenue</th>
                <th rowspan="2">new projects</th>
                <template v-for="(groupData, groupName, index) in groups">
                  <th
                    v-if="groupData.visible"
                    :key="groupName"
                    class="text-center"
                    :colspan="(getHeaderNames(groupName) ? getHeaderNames(groupName).length : 1) + (Object.keys(groups).filter((key, i) => i > index && groups[key].visible).length === 0 ? 1 : 0)">
                    {{ groupData.label }} ({{ groupData.type.replace('_', ' ') }})
                  </th>
                </template>
              </tr>
              <tr
                class="group-border group-border-header"
              >
                <template v-for="(groupData, groupName, groupIndex) in groups">
                  <template v-for="(headerName, i) in getHeaderNames(groupName)">
                    <th v-if="groupData.visible" :key="groupName + i"
                        :class="[ `column-` + groupData.type,  getDynamicClass(i, getHeaderNames(groupName).length) ]"
                        :colspan="(Object.keys(groups).filter((key, idx) => idx > groupIndex && groups[key].visible).length === 0 && i === getHeaderNames(groupName).length - 1) ? 2 : 1">
                      {{ headerName }}
                    </th>
                  </template>
                </template>
              </tr>
            </b-thead>
            <b-tbody class="report-t-body">
              <b-tr class="all-time-row">
                <b-td class="text-left">All time</b-td>
                <b-td>{{ reportData.summary.revenue }}</b-td>
                <b-td class="column-new_projects">
                  <span
                    v-b-tooltip.hover.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
                    :title="reportData.summary.new_projects.projects_list.join(', ')">
                    {{ reportData.summary.new_projects.value }}
                  </span>
                </b-td>
                <template v-for="(groupData, groupName) in groups">
                  <template v-for="(headerName, i) in getHeaderNames(groupName)">
                    <b-td v-if="groupData.visible" :key="groupName + i"
                          :class="[ `column-` + groupData.type,  getDynamicClass(i, getHeaderNames(groupName).length) ]">
                      <template v-if="groupData.type === 'revenue' && reportData.summary[groupName][headerName]">
                        {{ reportData.summary[groupName][headerName] }}
                      </template>
                      <template
                        v-else-if="groupData.type === 'new_projects' && reportData.summary[groupName][headerName]">
                        <span
                          v-b-tooltip.hover.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
                          :title="reportData.summary[groupName][headerName]['projects_list'].join(', ')">
                          {{ reportData.summary[groupName][headerName]['value'] }}
                        </span>
                      </template>
                      <template v-else>0</template>
                    </b-td>
                  </template>
                </template>
                <b-td class="border-right-0" />
              </b-tr>
              <b-tr class="empty-row"></b-tr>
              <template v-for="(yearData, i) in reportData.data">
                <b-tr
                  v-if="yearData.year"
                  :key="'year-' + yearData.year + '-' + i"
                  class="group-border"
                  :class="{'expanded-year': expandedYear === yearData.year}"
                >
                  <b-td class="date-column font-weight-bold">{{ yearData.year }}</b-td>
                  <b-td>{{ yearData.summary.revenue }}</b-td>
                  <b-td class="column-new_projects">
                    <span v-b-tooltip.hover.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
                          :title="yearData.summary.new_projects.projects_list.join(', ')">
                      {{ yearData.summary.new_projects.value }}
                    </span>
                  </b-td>
                  <template v-for="(groupData, groupName) in groups">
                    <template v-for="(headerName, i) in getHeaderNames(groupName)">
                      <b-td
                        v-if="groupData.visible"
                        :key="groupName + i"
                        :class="'column-' + groupData.type">
                        <template v-if="groupData.type === 'revenue' && yearData.summary[groupName][headerName]">
                          {{ yearData.summary[groupName][headerName] || 0 }}
                        </template>
                        <template
                          v-else-if="groupData.type === 'new_projects' && yearData.summary[groupName][headerName]">
                          <span
                            v-b-tooltip.hover.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
                            :title="
                              yearData.summary[groupName][headerName][
                                'projects_list'
                              ].join(', ')
                            "
                          >
                            {{ yearData.summary[groupName][headerName]["value"] }}
                          </span>
                        </template>
                        <template v-else>0</template>
                      </b-td>
                    </template>
                  </template>
                  <b-td class="arrow-icon">
                    <span
                      class="material-symbols-outlined"
                      @click="toggleYear(yearData.year)"
                    >
                      {{
                        expandedYear === yearData.year
                          ? "keyboard_arrow_up"
                          : "keyboard_arrow_down"
                      }}
                    </span>
                  </b-td>
                </b-tr>
                <template v-if="expandedYear !== yearData.year">
                  <b-tr :key="i" class="empty-row"></b-tr>
                </template>
                <template v-else>
                  <b-tr
                    v-for="(monthData, index) in yearData.data"
                    :key="monthData.month + '-' + index"
                    class="month-row"
                    :class="{
                      'month-row-first-in-group': index === 0,
                      'month-row-last-in-group': index === yearData.data.length - 1,
                    }"
                  >
                    <b-td class="text-left">{{ getMonthName(monthData.month) }}</b-td>
                    <b-td>{{ monthData.data.revenue }}</b-td>
                    <b-td class="column-new_projects">
                      <span
                        v-b-tooltip.hover.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
                        :title="
                          monthData.data.new_projects.projects_list.join(', ')
                        "
                      >
                        {{ monthData.data.new_projects.value }}
                      </span>
                    </b-td>
                    <template v-for="(groupData, groupName) in groups">
                      <template
                        v-for="(headerName, i) in getHeaderNames(groupName)"
                      >
                        <b-td
                          v-if="groupData.visible"
                          :key="groupName + i"
                          :class="[ `column-` + groupData.type,  getDynamicClass(i, getHeaderNames(groupName).length) ]"
                        >
                          <template
                            v-if="
                              groupData.type === 'revenue' &&
                              monthData.data[groupName][headerName]
                            "
                          >
                            {{ monthData.data[groupName][headerName] }}
                          </template>
                          <template
                            v-else-if="
                              groupData.type === 'new_projects' &&
                              monthData.data[groupName][headerName]
                            "
                          >
                            <span
                              v-b-tooltip.hover.html="{ variant: 'base', placement: 'top', placement:'top', boundary:'viewport' }"
                              :title="
                                monthData.data[groupName][headerName][
                                  'projects_list'
                                ].join(', ')
                              "
                            >
                              {{ monthData.data[groupName][headerName]["value"] }}
                            </span>
                          </template>
                          <template v-else>0</template>
                        </b-td>
                      </template>
                    </template>
                    <b-td class="border-0"></b-td>
                  </b-tr>
                  <b-tr :key="i" class="empty-row"></b-tr>
                </template>
              </template>
            </b-tbody>
          </HistoricalReportTable>
        </div>
        <h3 class="title">Charts</h3>
        <div class="charts-container">
          <template v-for="(groupData, groupName, index) in groups">
            <fullscreen
              background="#F3F5F7"
              ref="fullscreen"
              :key="groupName"
              @change="fullScreenChange"
              v-show="groupData.visible"
              class="charts-w"
            >
              <div class="col-12 py-4 pr-4 pl-0 charts-bg">
                <div class="d-flex w-100 justify-content-between">
                <div class="sales-report-chart-title">
                  {{ groupData.label }} ({{ groupData.type.replace("_", " ") }})
                </div>
                <b-button
                  class="button btn-icon"
                  variant="outline-info"
                  @click="toggleFullscreen(index)"
                >
                  <span class="material-icons">fullscreen</span>
                </b-button>
                </div>
                <canvas class="report-chart" :id="`chart-` + groupName">
                  Your browser does not support the canvas element.
                </canvas>
              </div>
           </fullscreen>
         </template>
        </div>
      </div>

      <EmptyStateNoResults
        v-else
        title="No sales report historical yet"
        description="No sales data available for this period. Once sales are recorded, your report will appear here."
        :customSvg="salesReportSvg"
        :withoutButton="true"
      />
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapGetters } from 'vuex'
import Chart from 'chart.js'
import { permissions } from '@mocks/permissions'
import StickyHeaderMixin from '../mixins/StickyHeaderMixin'
import Preloader from '@components/Preloader'
import HistoricalReportTable from '@components/finance/HistoricalReportTable.vue'
import PageHeader from '@components/PageHeader.vue'
import EmptyStateNoResults from '@components/EmptyStateNoResults.vue'
import { salesReportSvg } from '@/assets/icons/salesReportIcon.js'

export default {
  name: 'FinanceSalesReportHistoricalPage',
  mixins: [StickyHeaderMixin],
  components: {
    Preloader,
    HistoricalReportTable,
    PageHeader,
    EmptyStateNoResults
  },
  data () {
    return {
      permissions: permissions,
      showLastMonth: false,
      groups: {
        business_developers_revenue: { label: 'business development managers', type: 'revenue', visible: true },
        pre_sales_managers_revenue: { label: 'pre-sales managers', type: 'revenue', visible: true },
        sales_channels_revenue: { label: 'sales channels', type: 'revenue', visible: true },
        business_developers_new_projects: { label: 'business development managers', type: 'new_projects', visible: false },
        pre_sales_managers_new_projects: { label: 'pre-sales managers', type: 'new_projects', visible: false },
        sales_channels_new_projects: { label: 'sales channels', type: 'new_projects', visible: false }
      },
      expandedYear: null,
      fullscreen: false,
      reportData: {
        'data': [],
        'summary': {}
      },
      salesReportSvg: salesReportSvg,
      charts: [],
      profitMarginChart: null,
      revenueProfitChart: null
    }
  },
  computed: {
    ...mapGetters({
      _getAllUsers: 'getAllUsers'
    }),
    revenueGroups () {
      return Object.values(this.groups).filter(group => group.type === 'revenue')
    },
    newProjectsGroups () {
      return Object.values(this.groups).filter(group => group.type === 'new_projects')
    },
    getDataForChart: () => function (groupName) {
      const monthData = []
      const reportData = this.reportData.data
      for (const yi in reportData) {
        const year = reportData[yi].year
        const yearData = reportData[yi].data
        for (const mi in yearData) {
          const data = cloneDeep(yearData[mi].data[groupName])
          monthData.push({ month: yearData[mi].month, year, data: data })
        }
      }
      return monthData.reverse()
    },
    getHeaderNames: () => function (block) {
      if (this.reportData.summary[block]) {
        return Object.keys(this.reportData.summary[block]).sort((a, b) => {
          const indexA = ['no presales'].indexOf(a)
          const indexB = ['no presales'].indexOf(b)
          if (indexA !== -1) {
            return 1
          } else if (indexB !== -1) {
            return -1
          } else {
            return a - b
          }
        })
      } else {
        return []
      }
    }
  },
  watch: {
    async showLastMonth (value) {
      await this.fetchReportData(value)
      this.charts.forEach((chart) => chart.destroy())
      this.createCharts()
    }
  },
  async created () {
    await this._toggleDataPageLoading(async () => {
      await this.$api.users.getAllUsers()
      await this.$api.finances
        .getReportsSalesHistorical({ 'show-last-month': this.showLastMonth })
        .then((response) => {
          this.reportData = response.data
        })
    })
    this.$nextTick(() => {
      this.createCharts()
      this.startObserving()
    })
  },
  methods: {
    async fetchReportData (showLastMonth = false) {
      const result = await this._toggleDataPageLoading(async () => {
        try {
          const response = await this.$api.finances
            .getReportsSalesHistorical({ 'show-last-month': showLastMonth })
          this.reportData = response.data
        } catch (error) {
          console.error('Error fetching sales report data:', error)
        }
      })
      this.$nextTick(() => {
        this.startObserving()
      })
      return result
    },
    toggleFullscreen (index) {
      const fullscreenRef = this.$refs['fullscreen'][index]
      if (fullscreenRef && typeof fullscreenRef.toggle === 'function') {
        fullscreenRef.toggle()
      }
    },
    fullScreenChange (fullscreen) {
      this.fullscreen = fullscreen
    },
    getDynamicClass (index, length) {
      if (index === 0) {
        return 'border-right-0'
      } else if (index === length - 1) {
        return 'border-left-0'
      } else {
        return 'border-both-0'
      }
    },
    getMonthName (dateString) {
      const monthNumber = dateString.slice(-2)
      const monthNames = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ]

      return monthNames[parseInt(monthNumber, 10) - 1]
    },
    toggleYear (year) {
      this.expandedYear = this.expandedYear === year ? null : year
    },
    createCharts () {
      for (const groupName in this.groups) {
        const group = this.groups[groupName]
        this.createChart(groupName, group.type)
      }
    },
    createChart (groupName, groupType) {
      const chartCont = document.getElementById(`chart-` + groupName).getContext('2d')
      const chartData = this.getDataForChart(groupName)

      const monthsLabels = chartData.map(monthData =>
        new Date(monthData.month).toLocaleDateString('en-US', { year: 'numeric', month: 'short' })
      )

      const colors = ['#2F80ED', '#FFB401', '#E138B9', '#B9E530', '#863BFE', '#A8567A', '#627A9F', '#ED95C8', '#2BAF00']
      const items = this.getHeaderNames(groupName)
      const datasets = []
      for (const i in items) {
        const itemName = items[i]

        const itemData = chartData.map(monthData => {
          if (monthData.data[itemName]) {
            return monthData.data[itemName]['value'] ?? monthData.data[itemName]
          }
          return 0
        })
        const itemColor = colors.shift()

        datasets.push({
          label: itemName,
          data: itemData,
          stack: 'month',
          backgroundColor: itemColor,
          borderColor: itemColor,
          borderWidth: 1
        })
      }

      this.charts.push(new Chart(chartCont, {
        type: 'bar',
        data: {
          labels: monthsLabels,
          datasets: datasets
        },
        options: {
          legend: {
            position: 'bottom',
            labels: {
              fontSize: 12,
              usePointStyle: true
            }
          },
          scales: {
            xAxes: [{
              ticks: {
                fontSize: 8,
                fontColor: '#4F4F4F'
              }
            }],
            yAxes: [{
              display: true,
              scaleLabel: {
                display: true,
                fontSize: 14
              }
            }]
          }
        }
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
div.sales-report-historical {
  ::v-deep table {
    width: initial;
  }

  tbody tr td.column-new_projects {
    cursor: default;
  }
}

.charts-bg {
  border-radius: 10px;
  background-color: white;
}

.charts-w {
  width: 49%;
}

.charts-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  gap: 20px;
}

.sales-report-chart-title {
  font-size: 22px;
  text-align: left;
  font-weight: 500;
  margin-left: 20px;
  margin-bottom: 10px;
}

.sales-report-chart-title::first-letter {
  text-transform: uppercase;
}

.title-sales {
  font-weight: 500;
  text-wrap: nowrap;
}
</style>
